module.exports = __webpack_public_path__ + "img/polygon.943b500d.png";